var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"todo-list"},[(!_vm.todos.length)?_c('div',{staticStyle:{"padding":"1rem"}},[_c('Hint',[_vm._v(_vm._s(_vm.$t("todos.no_todos")))])],1):_c('div',_vm._l((_vm.todos),function(todo,index){return _c('TodoItem',{key:index,attrs:{"todo":todo}})}),1),(_vm.isUserDpo)?_c('TodoAdd'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }